export type INotificationMessage =
  | string
  | {
      content: string;
      name?: string;
      timeout?: number;
    };

export interface INotificationDelegate {
  success: (message: INotificationMessage) => number;
  info: (message: INotificationMessage) => number;
  warn: (message: INotificationMessage) => number;
  error: (message: INotificationMessage) => number;
  dismissAlertByName: (name: string) => void;
}

angular
  .module('capability-ng-academic-planner')
  .factory('ngAPNotificationDelegate', (phxNotificationDelegate: any) =>
    phxNotificationDelegate.restrictTo('ap-alerts')
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/helpers/notification_delegate.ts